import { render } from "./ReferencesList.vue?vue&type=template&id=e1e3be2a"
import script from "./ReferencesList.vue?vue&type=script&lang=js"
export * from "./ReferencesList.vue?vue&type=script&lang=js"

import "./ReferencesList.vue?vue&type=style&index=0&id=e1e3be2a&lang=css"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__